import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { ConversationsList } from "../components/ConversationsList";
import { useConversations } from "../hooks/conversationQueries";
import { useMessages } from "../hooks/messageQueries";

export function ConversationsListPage() {
  const { business, businessId, loading } = useCurrentBusiness();
  const { goToConversation } = useAppNavigation();
  const conversationsQuery = useConversations();
  const previewsQuery = useMessages(undefined, !!conversationsQuery.data?.length);
  const refreshing = conversationsQuery.isFetching || previewsQuery.isFetching;

  const refresh = () => {
    if (!businessId) return;
    void conversationsQuery.refetch();
    if (conversationsQuery.data?.length) void previewsQuery.refetch();
  };

  return (
    <Page>
      <PageHeader title="Messages" actions={
        <PageHeaderAction onClick={refresh} disabled={!businessId || refreshing}>
          {refreshing ? "Refreshing..." : "Refresh"}
        </PageHeaderAction>
      } />
      <PageContent className="space-y-[26px]">
        <ConversationsList
          key={businessId}
          conversations={conversationsQuery.data || []}
          messages={previewsQuery.data}
          timeZone={business?.timezone || "UTC"}
          isLoading={loading || conversationsQuery.isLoading}
          error={conversationsQuery.error}
          onRetry={refresh}
          onConversationClick={(conversation) => goToConversation(conversation.id)}
        />
        {previewsQuery.error && !conversationsQuery.error && (
          <ErrorState title="Message previews unavailable" message="You can still open a conversation. Refresh to try loading its preview again." onRetry={refresh} />
        )}
      </PageContent>
    </Page>
  );
}
